import React, { useRef, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useFormPageHandler, useForceRender, useMergeState } from 'irmlib/hooks'
import { CancelButton, SaveButton, TextField, Autocomplete } from 'irmlib/components/FormControls'
import { LocalToast, openGeneralDialog, closeGeneralDialog, setBusy, clearBusy } from 'irmlib/containers'
import { ThemeButton, Box, OutlinedButton, ClickableSvgIcon } from 'irmlib/components/Controls'
import { Add } from 'irmlib/icons'
import Close from '../../../icons/svg/close'
import * as constants from 'irmlib/common/constants'
import { addFormTemplate } from 'irmlib/components/FormControls/common'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import styled from 'styled-components'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import * as routePaths from '../../../navigation/routePaths'
import { getUser, indexOfAssignJob } from '../../../redux/global'
// import { indexOfAssignJob } from '../../../redux/global'
import { useTranslation } from 'react-i18next'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const AlignCloseIcon = styled('div')`
    display: flex;
    justify-content: flex-end;
    width: 10%;
  `

const AddBox = styled('div')`
display: flex;
justify-content: flex-end;
`

const SelectDataEntryContainer = styled('div')`
  width: 100%;
`

const SelectVerificationContainer = styled('div')`
  width: 90%;
`

const StyledHalfScreen = styled(HalfScreen)`
  display: flex;
  flex-direction: row;
`
const RecordCountContainer = styled('div')`
  visibility: hidden;
`

const VerticalDivider = () =>
  <YDivider height='50px' />

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const getService = async () => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const SELECT_JOB_ID = 0
const SELECT_DATA_ENTRY_USER = 1
const SELECT_RECORD_COUNT = 2
const SELECT_VERIFICATION_USER = 3

const INITIAL_USER_COUNT = 1
const INITIAL_FIELD_COUNT = 4

const initialSate = {
  jobIds: [],
  jobDetails: {},
  entryUserList: [],
  verifyUserList: [],
  workerList: [],
  verificationRequired: true,
  isSubmit: false,
  keyCount: 0
}

let loggedInUserDistrict
// eslint-disable-next-line
let templateSelected = ''

const JobAssignment = () => {
  const { t } = useTranslation()
  const [state, setState, getState] = useMergeState(initialSate)
  const refLocalBusyCursor = useRef(null)
  const refLocalToast = useRef(null)
  const newFormFieldList = useRef([])
  const forceRender = useForceRender()
  const history = useHistory()
  let jobId
  const location = useLocation()
  const JobId = location.pathname.split('/')[2]
  const AccessMode = location.pathname.split('/')[3]
  const [errorList, setErrorList] = useState({})
  const [entryUserList, setEntryUserList] = useState({})
  const [allowAssignPerms, setAllowAssignPerms] = useState(true)
  const additionalGivenPermissions = (getUser()?.userRolesObj?.gdeRole === 'Admin' || getUser()?.userRolesObj?.gdeRole === 'Super User' || getUser()?.userRolesObj?.gdeRole === 'Supervisor') 
    ? true 
    : window?.sessionStorage?.getItem('additional-permissions-user') 
      ? JSON.parse(window?.sessionStorage?.getItem('additional-permissions-user')) 
      : null
  const labelText = additionalGivenPermissions === true ? additionalGivenPermissions : additionalGivenPermissions[indexOfAssignJob]?.enabled

  const Buttons = props =>
    <>
      <CancelButton id={'assignJob_cancel'} onClick={props.openDialog} arrRefs={props.arrRefs} />
      <XDivider width='10px' />
      {getState()?.jobDetails?.isUploadCustomerDataFile && AccessMode === undefined
        ? <>
          <SaveButton id={'assignJob_save'} disabled={getState().isSubmit} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.saveAndUpload' />
          <XDivider width='10px' />
          <SaveButton id={'assignJob_save'} disabled={getState().isSubmit} arrRefs={props.arrRefs} postService={props.postServiceUploadDataLater} saveLabel='buttons.saveAndUploadLater' />
        </>
        : <SaveButton id={'assignJob_save'} disabled={getState().isSubmit} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.save' />
      }
    </>

  Buttons.propTypes = {
    arrRefs: PropTypes.array,
    postService: PropTypes.func,
    postServiceUploadDataLater: PropTypes.func,
    openDialog: PropTypes.func
  }

  const formTemplate = [
    {
      label: 'demo.jobID',
      fieldKey: 'jobID',
      isRequired: true,
      isRequiredError: 'forms.required',
      defaultValue: JobId,
    },
    labelText
      ? {
          label: 'demo.dataEntryUserAssign',
          fieldKey: 'assignedUsers.0.dataEntryUser',
          isRequired: true,
          fieldCount: 2
        }
      : {
          label: 'demo.dataEntryUser',
          fieldKey: 'assignedUsers.0.dataEntryUser',
          isRequired: true,
          fieldCount: 2
        },
    {
      label: 'demo.recordCountflash',
      fieldKey: 'recordNotifyCount',
      defaultValue: 50,
      isRequired: true,
      maxLength: 4,
      minValue: 1,
    },
    labelText
      ? {
          label: 'demo.verificationUserAssign',
          fieldKey: 'assignedUsers.0.verificationUser',
          isRequired: true,
          fieldCount: 3
        }
      : {
          label: 'demo.verificationUser',
          fieldKey: 'assignedUsers.0.verificationUser',
          isRequired: true,
          fieldCount: 3
        },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  useEffect(() => {
    if (location.pathname.split('/').length > 2) {
      const user = getUser()
      loggedInUserDistrict = user.district
      getJobDetails()
    }
  }, [])

  const getJobDetails = async () => {
    setBusy()
    jobId = location.pathname.split('/')[2]
    const jobData = await gdeTransactions.getJobById(jobId)
    const jobDetails = jobData.data()
    const user = getUser()
    // const workerCollection = await gdeTransactions.getWorkersWithDistrict(loggedInUserDistrict)    
    const workerCollection = await gdeTransactions.getworkersLists(loggedInUserDistrict)
    const workerDropList = [defaultSelectOption]
    const workerList = []
    const userList = []
    workerCollection.forEach((doc) => {
      if (!doc.data().isDeleted) {
        workerDropList.push({
          value: doc.id,
          label: `${doc.data().firstName} ${doc.data().lastName}-${doc.id.replace(/\d(?=\d{3})/g, '*')}`
        })
      }
      workerList[doc.id] = doc.data()
    })
    // const templateName = jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName
    // const template = await gdeTransactions.getTemplateById(templateName)
    // const templateDetails = template.data()
    if (additionalGivenPermissions[indexOfAssignJob]?.enabled === false && getUser()?.userRolesObj?.gdeRole === 'Data Entry') {
      setAllowAssignPerms(false)
    }
    const templateDetails = jobDetails.templateData
    let isVerify = false
    const fields = templateDetails?.templateFields

    Object.keys(fields).map((key) => {
      if (fields[key].verify) {
        if (key !== 'skpBoxId') {
          isVerify = true
        }
      }
      return null
    })

    setState({
      jobDetails: jobDetails,
      templateDetails: templateDetails,
      jobIds: [{ value: jobId, label: jobId }],
      entryUserList: workerDropList,
      verifyUserList: workerDropList,
      verificationRequired: isVerify,
      workerList: workerList
    })
    setTimeout(() => {
      arrRefs[SELECT_DATA_ENTRY_USER]?.current?.setValue(user?.workerId)
      getState().verificationRequired && arrRefs[SELECT_VERIFICATION_USER]?.current?.setValue(user?.workerId)
    }, 500)
    templateSelected = getState()?.jobDetails?.dataEntryType
    formTemplate[SELECT_JOB_ID].defaultValue = jobId
    if (jobDetails.recordNotifyCount !== '') {
      arrRefs[SELECT_RECORD_COUNT].current.setValue(jobDetails.recordNotifyCount)
    }
    let i = 0
    if (jobDetails.assignedUsers) {
      for (const user in jobDetails.assignedUsers) {
        if (jobDetails.assignedUsers[user].jobCategory.includes('Data Entry User')) {
          userList[i] = {
            dataEntryUser: user,
            verificationUser: jobDetails.assignedUsers[user].verifyUser
          }
          i++
        }
      }
      if (userList.length !== 0) {
        arrRefs[SELECT_DATA_ENTRY_USER]?.current?.setValue(userList[0].dataEntryUser)
        if (getState().verificationRequired) {
          arrRefs[SELECT_VERIFICATION_USER]?.current?.setValue(userList[0].verificationUser)
        }
      }
      let index = INITIAL_FIELD_COUNT
      for (let key = 1; key < userList.length; key++) {
        addFormField()
        arrRefs[index]?.current?.setValue(userList[key].dataEntryUser)
        if (getState().verificationRequired) {
          arrRefs[index + 1]?.current?.setValue(userList[key].verificationUser)
          index = index + 2
        } else {
          index = index + 1
        }
      }
    }
    clearBusy()
  }
  const arr = [...newFormFieldList.current]
  const ButtonsForDialogBox = props =>
    <>
      <OutlinedButton onClick={handleCancelButtonOnClick} >buttons.exitJob</OutlinedButton>
      <ContainedButton onClick={closeGeneralDialog} >buttons.continueWithAssignment</ContainedButton>
    </>
  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(routePaths.root)
  }
  const handleEntryCloseIcon = (index, count) => {
    // removing the user pair from arrRefs
    for (const key in arrRefs) {
      const keyCount = arrRefs[key]?.current?.getFormTemplate().keyCount
      if (keyCount !== undefined) {
        if (keyCount === index) {
          if (getState().verificationRequired) {
            arrRefs.splice(key, 2)
            delete errorList[keyCount]
            delete entryUserList[keyCount]
            break
          } else {
            arrRefs.splice(key, 1)
            delete errorList[keyCount]
            delete entryUserList[keyCount]
            break
          }
        }
      }
    }
    // removing the user pair from the form array
    newFormFieldList.current.forEach((ele, i) => {
      if (parseInt(ele.key) === index) {
        newFormFieldList.current.splice(i, 1)
      }
    })
    forceRender()
    setState({ isSubmit: false })
  }
  const openDialog = () => {
    openGeneralDialog({
      title: t('forms.cancelAssignment'),
      message: t('messages.cancelAssignmentMessage',
        { jobId: JobId }),
      buttons: <ButtonsForDialogBox />,
      noTranslateMessage: true,
      noTranslateTitle: true,
      closeX: true
    })
  }
  const getJobDoc = (postObject, customTemplateName) => {
    const userKeys = {}
    const dataEntryUsers = []
    const verificationUsers = []
    let assignUserList = []

    for (const key in postObject.assignedUsers) {
      const obj = postObject.assignedUsers[key]

      if (!dataEntryUsers.includes(obj.dataEntryUser)) {
        dataEntryUsers.push(obj.dataEntryUser)
      }
      if (getState().verificationRequired && !verificationUsers.includes(obj.verificationUser)) {
        verificationUsers.push(obj.verificationUser)
      }

      if (obj.dataEntryUser in userKeys) {
        if (!userKeys[obj.dataEntryUser].jobCategory.includes('Data Entry User')) {
          userKeys[obj.dataEntryUser].jobCategory.push('Data Entry User')
        }

        if (getState().verificationRequired) {
          userKeys[obj.dataEntryUser].verifyUser = obj.verificationUser
        }
      } else {
        userKeys[obj.dataEntryUser] = {
          completedBoxes: 0,
          status: getState().workerList[obj.dataEntryUser].status ? getState().workerList[obj.dataEntryUser].status : '',
          jobCategory: ['Data Entry User'],
          verifyUser: getState().verificationRequired ? obj.verificationUser : '',
          workerName: `${getState().workerList[obj.dataEntryUser].firstName} ${getState().workerList[obj.dataEntryUser].lastName}`
        }
      }

      if (getState().verificationRequired) {
        if (obj.verificationUser in userKeys) {
          if (userKeys[obj.verificationUser].jobCategory === undefined) {
            userKeys[obj.verificationUser].jobCategory = []
          }
          if (!userKeys[obj.verificationUser].jobCategory.includes('Verification User')) {
            userKeys[obj.verificationUser].jobCategory.push('Verification User')
          }
        } else {
          userKeys[obj.verificationUser] = {
            completedBoxes: 0,
            status: getState().workerList[obj.verificationUser].status ? getState().workerList[obj.verificationUser].status : '',
            jobCategory: ['Verification User'],
            workerName: `${getState().workerList[obj.verificationUser].firstName} ${getState().workerList[obj.verificationUser].lastName}`
          }
        }
      }
    }

    assignUserList = Object.keys(userKeys)
    const status = getState().jobDetails.jobStatus === 'Assigned' || getState().jobDetails.jobStatus === 'Pending' ? constants.jobStatus.assigned : constants.jobStatus.inProgress
    const autoTransmit = (getState().jobDetails.autoTransmit === undefined) ? 'true' : getState().jobDetails.autoTransmit
    const jobDoc = {
      recordNotifyCount: postObject.recordNotifyCount,
      assignedUsers: userKeys,
      autoTransmitAndStatus: `${autoTransmit}-${status}`,
      jobStatus: status,
      assignedUserList: assignUserList
    }
    return jobDoc
  }


  const postService = async postObject => {
    const jobData = getJobDoc(postObject)

    gdeTransactions.updateJob(JobId, jobData)
      .then(() => {
        refLocalToast.current?.successToastOn({
          message: t('toast.jobAssigned'),
          title: t('toast.jobManagement'),
          noTranslateMessage: true,
          noTranslateTitle: true
        })
        setTimeout(() => {
          // history.goBack()
          if (getState()?.jobDetails?.isUploadCustomerDataFile && AccessMode === undefined) {
            history.push(`${routePaths.UploadCustomerData}/${JobId}`)
          } else {
            history.push(`${routePaths.createJob}`)
          }
        }, 3000)
      })

    return Promise.resolve()
  }

  const postServiceUploadDataLater = async postObject => {
    const jobData = getJobDoc(postObject)

    gdeTransactions.updateJob(JobId, jobData)
      .then(() => {
        refLocalToast.current?.successToastOn({
          message: t('toast.jobAssigned'),
          title: t('toast.jobManagement'),
          noTranslateMessage: true,
          noTranslateTitle: true
        })
        setTimeout(() => {
          history.push(`${routePaths.createJob}`)
        }, 3000)
      })
    return Promise.resolve()
  }

  const handleErrorMsg = (userId, fieldCount, key) => {
    const updateErrorList = errorList
    if (key !== undefined) {
      updateErrorList[key] = userId
    }
    arrRefs[fieldCount]?.current?.setErrorMsg('messages.duplicateDeEntry')
    setErrorList(updateErrorList)
  }

  const handleErrorChange = (changingValue) => {
    const updateDataEntryList = entryUserList
    for (const [key, value] of Object.entries(errorList)) {
      if (value === changingValue) {
        for (const arr in arrRefs) {
          const keyCount = arrRefs[arr]?.current?.getFormTemplate().keyCount
          if (keyCount !== undefined && keyCount === parseInt(key)) {
            arrRefs[arr]?.current?.clearErrorMsg()
          }
        }
        delete errorList[key]
        updateDataEntryList[key] = value
        break
      }
    }

    setEntryUserList(updateDataEntryList)
  }

  // onChange event for dynamically adding user fields
  const onChangeEntryUser = (e, userCount) => {
    let isDisable = false
    let fieldKeyCount = 0

    // calculating fieldCount using the row count when we are adding users
    if (getState().verificationRequired) {
      fieldKeyCount = (userCount * 2) + 2
    } else {
      fieldKeyCount = userCount + 3
    }
    const uniqueKey = arrRefs[fieldKeyCount]?.current?.getFormTemplate().keyCount
    const localEntryUserList = entryUserList
    const changingValue = localEntryUserList[uniqueKey]

    const dataEntryUser = e

    const entryListValues = []
    const entryErrorList = []
    for (const key in errorList) {
      entryErrorList.push(errorList[key])
    }

    for (const key in localEntryUserList) {
      entryListValues.push(localEntryUserList[key])
    }

    handleErrorChange(changingValue)

    if (!entryListValues.includes(dataEntryUser) && dataEntryUser !== constants.defaultSelect) {
      arrRefs[fieldKeyCount]?.current?.clearErrorMsg()
      if (getState().verificationRequired) {
        arrRefs[fieldKeyCount + 1]?.current?.setValue(dataEntryUser)
      }
      if (uniqueKey !== undefined) {
        localEntryUserList[uniqueKey] = dataEntryUser
      }

      setEntryUserList(localEntryUserList)
      isDisable = false
    } else if (entryListValues.includes(dataEntryUser)) {
      arrRefs[fieldKeyCount]?.current?.clearErrorMsg()

      handleErrorMsg(dataEntryUser, fieldKeyCount, uniqueKey)
      isDisable = true
    }

    setState({ isSubmit: isDisable })
  }

  // onChange event for fixed user fields
  const onChangeDeUser = (e) => {
    const localEntryUserList = entryUserList
    const changingValue = localEntryUserList[SELECT_DATA_ENTRY_USER]
    let isDisable = false
    const dataEntryUser = e

    const entryListValues = []
    const entryErrorList = []
    for (const key in errorList) {
      entryErrorList.push(errorList[key])
    }

    for (const key in localEntryUserList) {
      entryListValues.push(localEntryUserList[key])
    }

    handleErrorChange(changingValue)

    if (!entryListValues.includes(dataEntryUser) && dataEntryUser !== constants.defaultSelect) {
      arrRefs[SELECT_DATA_ENTRY_USER]?.current?.clearErrorMsg()
      if (getState().verificationRequired) {
        arrRefs[SELECT_VERIFICATION_USER].current.setValue(dataEntryUser)
      }
      localEntryUserList[SELECT_DATA_ENTRY_USER] = dataEntryUser
      setEntryUserList(localEntryUserList)
      isDisable = false
    } else if (entryListValues.includes(dataEntryUser)) {
      handleErrorMsg(dataEntryUser, SELECT_DATA_ENTRY_USER)
      isDisable = true
    }
    setState({ isSubmit: isDisable })
  }

  const addFormField = () => {
    // key should be unique for each pair of users 
    const userCount = Math.floor((Math.random() * 100) + INITIAL_USER_COUNT)
    const count = newFormFieldList.current.length + INITIAL_USER_COUNT


    const dataEntryAdd = {
      label: 'demo.dataEntryUserAssign',
      fieldKey: `assignedUsers.${userCount}.dataEntryUser`,
      defaultValue: constants.defaultSelect,
      isRequired: true,
      keyCount: userCount
    }

    const verificationAdd = {
      label: 'demo.verificationUserAssign',
      fieldKey: `assignedUsers.${userCount}.verificationUser`,
      defaultValue: constants.defaultSelect,
      isRequired: true,
      keyCount: userCount
    }

    const dataEntryUser = addFormTemplate({ fieldTemplate: dataEntryAdd, Component: Autocomplete, props: { options: getState().entryUserList, noTranslateItems: true, onChange: (e) => onChangeEntryUser(e, count) }, arrRefs })
    let verificationUser
    if (getState().verificationRequired) {
      verificationUser = addFormTemplate({ fieldTemplate: verificationAdd, Component: Autocomplete, props: { options: getState().verifyUserList, noTranslateItems: true }, arrRefs })
    }
    const newIndex = newFormFieldList.current.length
    newFormFieldList.current.push(
      <div key={userCount}>
        <FlexByRow>
          <StyledHalfScreen>
            <SelectDataEntryContainer>
              {dataEntryUser}
            </SelectDataEntryContainer>
          </StyledHalfScreen>
          <XDivider width='50px' />
          <StyledHalfScreen>
            {getState().verificationRequired
              ? <SelectVerificationContainer>
                {verificationUser}
              </SelectVerificationContainer>
              : null
            }
            <AlignCloseIcon>
              <ClickableSvgIcon
                onClick={() => handleEntryCloseIcon(userCount, newIndex)}
              >
                <Close scale={0.7} >
                </Close>
              </ClickableSvgIcon>
            </AlignCloseIcon>
          </StyledHalfScreen>
        </FlexByRow>
        <VerticalDivider />
      </div>
    )

    forceRender()
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      subTitle='forms.assignJob'
      buttons={<Buttons arrRefs={arrRefs} postService={postService} postServiceUploadDataLater={postServiceUploadDataLater} openDialog={openDialog} />}
    >
      <LocalToast ref={refLocalToast} />
      <FlexByRow>
        <HalfScreen>
          <TextField
            id={'assignJob_jobId'}
            data={data}
            fieldTemplate={formTemplate[SELECT_JOB_ID]}
            ref={arrRefs[SELECT_JOB_ID]}
            defaultValue={JobId}
            disabled={true}
          />
          <VerticalDivider />
          {/* <Select
            id={'assignJob_dataEntryUser'}
            onChange={onChangeDeUser}
            data={data}
            items={state.entryUserList}
            fieldTemplate={formTemplate[SELECT_DATA_ENTRY_USER]}
            ref={arrRefs[SELECT_DATA_ENTRY_USER]}
            noTranslateItems
          /> */}
          <Autocomplete
            // In place of Select we've added Autocomplete to search for the names
            id={'assignJob_dataEntryUser'}
            data={data}
            onChange={onChangeDeUser}
            options={state.entryUserList}
            fieldTemplate={formTemplate[SELECT_DATA_ENTRY_USER]}
            ref={arrRefs[SELECT_DATA_ENTRY_USER]}
            disabled={!allowAssignPerms}
            noTranslateItems
          />
          <VerticalDivider />
        </HalfScreen>
        <XDivider width='50px' />
        <HalfScreen>
          {getState()?.jobDetails?.dataEntryType === 'New File' || getState()?.jobDetails?.dataEntryType === 'Maintenance File'
            ? <>
              <TextField
                id={'assignJob_recordCount'}
                data={data}
                fieldTemplate={formTemplate[SELECT_RECORD_COUNT]}
                ref={arrRefs[SELECT_RECORD_COUNT]}
                type='number'
              /> </>
            : <RecordCountContainer><TextField
                id={'assignJob_recordCount'}
                data={data}
                fieldTemplate={formTemplate[SELECT_RECORD_COUNT]}
                ref={arrRefs[SELECT_RECORD_COUNT]}
                type='number'
            /> </RecordCountContainer>
          }
          <VerticalDivider />
          {/* {state.verificationRequired
            ? <Select
                id={'assignJob_verificationUser'} 
                data={data}
                items={state.verifyUserList}
                fieldTemplate={formTemplate[SELECT_VERIFICATION_USER]}
                ref={arrRefs[SELECT_VERIFICATION_USER]}
                noTranslateItems
            />
            : null
          } */}
          {state.verificationRequired
            ? <Autocomplete
                // In place of Select we've added Autocomplete to search for the names
                id={'assignJob_verificationUser'}
                data={data}
                options={state.verifyUserList}
                fieldTemplate={formTemplate[SELECT_VERIFICATION_USER]}
                ref={arrRefs[SELECT_VERIFICATION_USER]}
                disabled={!allowAssignPerms}
            />
            : null
          }
        </HalfScreen>
      </FlexByRow>
      {arr}
      {allowAssignPerms && <AddBox>
        <Box>
          <BottomPaddedButton id={'assignJob_addUser'} onClick={addFormField} startIcon={<Add />} variant='contained'>
            editJob.addUser
          </BottomPaddedButton>
        </Box>
      </AddBox>}
    </MainRouteSubRoutePage>
  )
}

export default JobAssignment